export default __webpack_public_path__ + "static/media/fad-arpdownandup.03f7d61b.svg";